import { createContext } from "react";
import type { HeaderContextType } from "./HeaderContext";

export const HeaderContext = createContext<HeaderContextType | undefined>(
  undefined,
);
